import { useQuery } from '@/hooks/useQuery';
import { api } from '@/services/api';
import { useChartStore } from '@/store/chartStore';
import type { EventsResponse } from '@/types';

export function useEvents(): { data: EventsResponse | null; loading: boolean; error: string | null } {
  const symbol = useChartStore((s) => s.symbol);
  return useQuery(() => api.events(symbol), [symbol]);
}
